import { TOUR_TRANSLATIONS } from "../translations"

export const getSellerDetailsSteps = (lang) => {
    const t = TOUR_TRANSLATIONS[lang]

    return [
        {
            target: '[data-tour="seller-details-filters"]',
            title: t.sellerDetailsFilters.title,
            content: t.sellerDetailsFilters.content,
            disableBeacon: true,
        },
        {
            target: '[data-tour="seller-details-table"]',
            title: t.sellerDetailsTable.title,
            content: t.sellerDetailsTable.content,
        },
    ]
}
